import RegiondoBookingCardBase from '../common/RegiondoBookingCardBase';

function BookingCardAxe({ booking, renderAvailableSlots }) {
  return (
    <RegiondoBookingCardBase
      booking={booking}
      color='#ffffff'
      renderAvailableSlots={renderAvailableSlots}
    />
  );
}

export default BookingCardAxe;
